import { createFileRoute } from '@tanstack/react-router'

import { forbiddenErrorComponent, requirePermission } from '@/lib/routeGuards'
import { RobotTraining } from '@/pages/RobotTraining/RobotTraining'

export const Route = createFileRoute('/_app/studio/robot-teaching')({
  component: RobotTraining,
  beforeLoad: ({ context }) => {
    requirePermission(context.permissions, 'read:robots:config')
  },
  errorComponent: forbiddenErrorComponent,
})
